<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Thumbs Down Filled" class="d-icon d-icon--thumbs-down-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path d="M5.995 11.438a.438.438 0 0 0 .396-.242l1.671-3.338V.722a.437.437 0 0 0-.337-.16H3.25a1.438 1.438 0 0 0-1.38 1.036l-1.165 4a1.438 1.438 0 0 0 1.38 1.84h2.359l-.369 1.517a2.002 2.002 0 0 0 1.92 2.482Zm2.942-4.005V.567A.441.441 0 0 1 9 .563h1A1.437 1.437 0 0 1 11.438 2v4A1.438 1.438 0 0 1 10 7.438H9a.441.441 0 0 1-.063-.005Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" transform="rotate(180 6 6)" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconThumbsDownFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
